<template>
  <aha-modal
    @hide="onCloseModal"
    title="Backstage Window"
  >
    <p class="mb-2">
      This window is just for you.
      Drag it to the screen only you can see.
    </p>
    <p>
      <aha-checkbox v-model="dontShowAgain">
        Don't show this message again
      </aha-checkbox>
    </p>
    <template #action>
      <aha-button
        @click="onCloseModal"
      >
        Got it
      </aha-button>
    </template>
  </aha-modal>
</template>

<script>

export default {
  name: 'PresenterWindowNotifyModal',
  data() {
    return {
      dontShowAgain: false,
    }
  },
  methods: {
    onCloseModal() {
      localStorage.setItem('PresenterWindowNotifyModal', JSON.stringify(this.dontShowAgain))
      this.$emit('hide')
    },
  },
}
</script>
